'use client'

import { useActions } from 'ai/rsc'
import { useState } from 'react'
import {
  FaRegThumbsDown,
  FaRegThumbsUp,
  FaThumbsDown,
  FaThumbsUp
} from 'react-icons/fa'

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger
} from './ui/dialog'

export function Feedback({ queryId }: { queryId: string }) {
  const [clicked, setClicked] = useState('')
  const [feedbackDetails, setFeedbackDetails] = useState('')
  const { feedback } = useActions()
  return (
    <>
      <div className="flex gap-4">
        {(!clicked || clicked === 'positive') && (
          <button
            disabled={!!clicked}
            onClick={() => {
              feedback({ feedback: 'positive', queryId })
              setClicked('positive')
            }}
          >
            {clicked ? <FaThumbsUp /> : <FaRegThumbsUp />}
          </button>
        )}
        <Dialog>
          {(!clicked || clicked === 'negative') && (
            <DialogTrigger disabled={!!clicked}>
              {clicked ? <FaThumbsDown /> : <FaRegThumbsDown />}
            </DialogTrigger>
          )}
          <DialogContent>
            <DialogTitle>Additional Feedback</DialogTitle>
            <DialogDescription>
              Please leave us your comments so we can improve. Thank you!
            </DialogDescription>

            <div className="flex flex-col gap-3">
              <label>
                <input
                  value={feedbackDetails}
                  onChange={e => setFeedbackDetails(e.target.value)}
                  type="text"
                  name="feedback-details"
                  placeholder=""
                  className="leading-5 resize-none max-h-60 pl-4 pr-14  rounded-full hover:shadow-lg hover focus-visible:shadow-lg flex  w-full border border-input py-3 text-base ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-ring  disabled:cursor-not-allowed disabled:opacity-50"
                />
              </label>
            </div>

            <div className="flex gap-3 mt-4 justify-end">
              <DialogClose>
                <button color="gray">Cancel</button>
              </DialogClose>
              <DialogClose>
                <button
                  disabled={!!clicked}
                  onClick={() => {
                    feedback({ feedback: 'negative', feedbackDetails, queryId })
                    setClicked('negative')
                  }}
                >
                  Save
                </button>
              </DialogClose>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  )
}
